import { render } from "./datatable.vue?vue&type=template&id=405e27af"
import script from "./datatable.vue?vue&type=script&lang=ts"
export * from "./datatable.vue?vue&type=script&lang=ts"
script.render = render

export default script